var assetCDN = "https://www.aexp-static.com/cdaas/one/statics/@americanexpress/static-assets/2.24.2/package/dist";

export { assetCDN };
